import { NumericFormat } from 'react-number-format';
import DOMPurify from "dompurify";

import Image from '../ui/Image';
import classes from './AttributeValue.module.css';

function AttributeValue(props) {
	const isImage = (props.isImage === 1 && props.attrMedia !== null) ? true : false;
	return (
		<li className={classes.listItem}>
			<div className={classes.container}>
				<input
					type="radio"
					name={props.attrId}
					id={props.id}
					value={props.id}
					checked={(typeof(props.selected[props.attrId]) !== 'undefined' && props.selected[props.attrId].attrId === props.id) ? ('checked') : ('')}
					disabled={(typeof(props.selected[props.attrId]) !== 'undefined' && props.selected[props.attrId].attrId === props.id) ? ('disabled') : ('')}
					onChange={() => props.filter(props.attrId, props.id, props.maavStep)}
					className={classes.attrInput}
				/>
				{isImage && <label htmlFor={props.id} className={classes.image_container}><Image
								key={props.id}
								id={props.id}
								name={props.valueId}
								filename={props.attrMedia.filename}
								filetype={props.attrMedia.filetype}
								filename_webp={props.attrMedia.filename_webp}
								className={classes.attrLabel}
							/>
							{typeof(props.quantity) !== "undefined" && <div className={props.quantity < 1 ? classes.imageOutOfStock : ''}></div>}
							</label>
				}
				{!isImage && 
					<label htmlFor={props.id} className={classes.attrLabel + ' ' + (typeof(props.basePrice) !== "undefined" ? classes.last : '') + ' ' + ((props.quantity < 1 && props.isSellableWhen0 === 0) ? classes.outOfStock : '')}>
						{ <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.valueId) }} /> }
						{(props.pricePreview === 1 && props.showStartingAt === 1) && <div className={classes.black}>Starting at</div>}
						{(typeof(props.basePrice) !== "undefined" && props.basePrice > props.price && props.pricePreview !== 1) && <div className={classes.basePrice + ' ' + ((props.quantity < 1 && props.isSellableWhen0 === 0) ? classes.outOfStock : '')}><strike><NumericFormat value={props.basePrice} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale /></strike></div>}
						{typeof(props.price) !== "undefined" && <div><div className={classes.price + ' ' + ((props.quantity < 1 && props.isSellableWhen0 === 0) ? classes.outOfStock : '')}><NumericFormat value={props.price} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale /></div><div className={classes.basePrice + ' ' + (((typeof(props.basePrice) !== "undefined" && props.basePrice > props.price) || props.pricePreview === 1) ? 'hidden' : '')}><span>&nbsp;</span></div></div>}
					</label>}
					{(typeof(props.selected[props.attrId]) !== 'undefined' && props.selected[props.attrId].attrId === props.id) && <div className={`${isImage ? "glyphicon glyphicon-ok green-check" : "glyphicon glyphicon-ok green-check-small"}`}></div>}
			</div>
			{(isImage && props.pricePreview === 1 && props.showStartingAt === 1) && <div>Starting at</div>}
			{(isImage && typeof(props.basePrice) !== "undefined" && props.basePrice > props.price && props.pricePreview !== 1) && <div className={classes.basePrice + ' ' + ((props.quantity < 1 && props.isSellableWhen0 === 0) ? classes.outOfStock : '')}><strike><NumericFormat value={props.basePrice} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale /></strike></div>}
			{(isImage && typeof(props.price) !== "undefined") && <div><div className={classes.imagePrice + ' ' + ((props.quantity < 1 && props.isSellableWhen0 === 0) ? classes.outOfStock : '')}><NumericFormat value={props.price} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale /></div><div className={classes.basePrice + ' ' + ((typeof(props.basePrice) !== "undefined" && props.basePrice > props.price) ? 'hidden' : '')}><span>&nbsp;</span></div></div>}
		</li>
	);
}

export default AttributeValue;
